<template>
  <div>
    <el-form ref="form" :model="form" class="form_flex">
      <el-row>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="统计时间段"
            prop="statisticsTime"
          >
            <el-date-picker
              v-model="statisticsTime"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="hanldeChangeTime"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="邀请人城市"
            :label-width="formLabelWidth"
            prop="areaId"
          >
            <el-cascader
              v-model="form.areaId"
              :props="props"
              @change="handleChangeValue"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="邀请人"
            :label-width="formLabelWidth"
            prop="userId"
          >
            <el-select
              class="select"
              v-model="form.userId"
              filterable
              remote
              placeholder="请输入邀请人"
              :remote-method="searchUser"
              @change="checkItem"
              clearable
              :loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="btn">
            <!-- @keyup.enter.native="searchEnterFun"  -->
            <el-button @click="onSearch" icon="el-icon-search" size="small"
              >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-delete"
              @click="resetForm('form')"
              >清空</el-button
            >
            <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
              >刷新</el-button
            >
            <PermissionsBtn2
              :icon="'el-icon-download'"
              :btnType="'primary'"
              :permissionName="'_Export'"
              :downloadUrl="'/userAdmin/Report/invitateDownLoad'"
              :form="exportForm"
              :checkList="checkList"
            ></PermissionsBtn2>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { getAreaListApi } from '@/api/areaApi.js';
import { mapGetters } from 'vuex';
import { getUserModelApi } from '@/api/user.js';
import { getToken } from '@/utils/token.js';
import { keyupEnter } from '@/utils/eventListener';
import PermissionsBtn2 from '@/components/PermissionsBtn2';
import { dateFormate } from '@/utils/dateFormate';
import { decrypt } from '@/utils/encryp';
export default {
  name: 'ReportStatistics',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  props: {
    checkList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    PermissionsBtn2,
  },
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      statisticsTime: [],
      loading: false,
      // 表单内容
      form: {
        startTime: '', //统计开始时间
        endTime: '', //统计结束时间
        areaId: '',
        userId: '',
        isExport: false,
      },
      exportForm: {
        areaId: '',
        startTime: '', //统计开始时间
        endTime: '', //统计结束时间
        userId: '',
        houseId: '',
        pageSize: 20,
        pageIndex: 1,
        isExport: true,
      },
      options: [],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          const userInfo = JSON.parse(getToken('userInfo'));
          let { areaId, roleType } = userInfo;
          if (level == 0) {
            getAreaListApi({ areaId, roleType }).then((res) => {
              if (res.code === 200) {
                // console.log(res.data, 'lalala');
                const arr = res.data.area.map((item) => {
                  return {
                    value: item.areaId,
                    label: item.areaName,
                    leaf: true,
                    // leaf: !item.houseDtos.length,
                  };
                });
                this.options = arr;
                resolve(arr);
              }
            });
          }
        },
      },
      enterBool: false,
      defaultValue: [],
      timeDefaultShow: '',
      defaultDateTime: [],
    };
  },
  computed: {
    ...mapGetters(['pickerOptions']),
  },
  watch: {
    enterBool(bool) {
      console.log('bool', bool);
    },
  },
  async mounted() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    this.statisticsTime = [start, end];

    // console.log('date', this.statisticsTime);
    // console.log('timeFormate', dateFormate(start));
    let startTime = dateFormate(start);
    let endTime = dateFormate(end);
    this.defaultDateTime = [startTime, endTime];

    this.exportForm['startTime'] = startTime;
    this.exportForm['endTime'] = endTime;

    // this.timeDefaultShow = new Date();
    // this.timeDefaultShow.setMonth(new Date().getMonth() - 1);

    // console.log('默认时间：', this.timeDefaultShow);

    // this. Enter(); //页面在创建时就调用键盘的回车事件，在结构代码中也可以不写@keyup.enter.native="handleAddBook"
    // document.onkeydown = (e) => {
    //   console.log('enter事件', e);
    //   // 为了更加严谨所以添加了路由路径的判断
    //   if (e.key === 'ENTER') {
    //     //回车后执行搜索方法
    //     this.onSearch();
    //   }
    // };
    // 默认一个月
    this.enterBool = await keyupEnter();
    // console.log('enterBool', this.enterBool);
    // if (bool) this.onSearch();
  },
  methods: {
    keyupEnter() {
      document.onkeydown = (e) => {
        // console.log(
        //   'URL',
        //   e.target.baseURI.match(this.$route.path),
        //   this.$route
        // );
        let body = document.getElementsByTagName('body')[0];
        if (e.key === 'Enter' && e.target === body) {
          this.onSearch();
        }
      };
    },
    handleClear() {
      console.log(22);
    },
    handleChangeValue(arr) {
      // console.log('城市选择：', arr);
      this.form.areaId = arr[0];
      this.exportForm['areaId'] = this.form['areaId'];
    },

    // 修改时间
    hanldeChangeTime(val) {
      // console.log('修改时间', val);
      if (!val) {
        this.exportForm['startTime'] = '';
        this.exportForm['endTime'] = '';
        return;
      }
      this.exportForm['startTime'] = val[0];
      this.exportForm['endTime'] = val[1];
    },

    // 搜索邀请人
    async searchUser(val) {
      this.loading = true;
      let res = await getUserModelApi({ userName: val, areaId: this.areaId });
      this.loading = false;
      this.options = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 选择下拉选项
    checkItem(val) {
      this.form.userId = val;
      this.exportForm.userId = val;
    },

    // 搜索，触发父组件请求数据的方法
    onSearch() {
      // 统计时间
      this.form['startTime'] = this.statisticsTime
        ? dateFormate(this.statisticsTime[0])
        : '';
      this.form['endTime'] = this.statisticsTime
        ? dateFormate(this.statisticsTime[1])
        : '';
      this.$emit('search', this.form);
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 清空表单
    resetForm(formName) {
      // this.statisticsTime = [];
      this.exportForm['areaId'] = '';
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 260px;
}

.search-select1 {
  // width: 120px;
}

.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
<style lang="less">
.invite-report {
  .el-table .total-row {
    background: beige;
  }
}
</style>
